module.exports = __webpack_public_path__ + "img/polucion.ec7f9164.svg";